export const _setStudentTrackerCellData = (state, action) => action.payload;

export const _setStudentTrackerColumnName = (state, action) => {
  state.studentTrackerColumnName = action.payload;
};
